<script>
import { EpisodeCardSmallElementMixin } from "%/dynamic-component-editor/standard-components/episode-card-small/episode-card-small-element-mixin";
import { DurationElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/duration-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

const VERB_BY_MEDIA_TYPE = {
  audio: "listen",
  video: "watch",
};

export default {
  name: "EpisodeDuration",
  elementPanelSettings: {
    displayName: "Duration",
    displayIcon: "nrk:duration",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [EpisodeCardSmallElementMixin, DurationElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    // Mirrors the FanWeb element exactly. The canvas used to render the raw
    // seconds (480) while fans saw "8 min listen".
    value() {
      const formatted = this.formattedDuration(this.entity.duration);
      if (formatted === "") {
        return "";
      }
      const verb = VERB_BY_MEDIA_TYPE[this.entity.mediaType];
      if (!verb) {
        return formatted;
      }
      return `${formatted} ${verb}`;
    },
  },
};
</script>
